import { ProductDataType } from '../model';
import { BundleData } from './types';
import _ from 'lodash';
import { FREE_EDITION_LABEL_KEY } from './constants';

export type GetBundleDataOptions = {
  readonly activeBundlesMap: { [key: string]: ProductDataType };
  readonly bundleName?: string;
  readonly productKeys?: string;
  readonly edition?: string;
};

export function getBundleData({
  activeBundlesMap,
  bundleName,
  productKeys,
  edition
}: GetBundleDataOptions): BundleData {
  let bundleData;

  if (bundleName && bundleName.length) {
    bundleData = getBundleDataByBundleName({
      activeBundlesMap,
      bundleName,
      edition
    });
  } else if (productKeys && productKeys.length) {
    bundleData = getBundleDataByProduct({
      activeBundlesMap,
      productKeys,
      edition
    });
  }

  // if all else fails, go with default
  if (!bundleData) {
    return {
      ...activeBundlesMap['default'],
      bundleName: 'default',
      edition: FREE_EDITION_LABEL_KEY.toLowerCase()
    };
  }

  return bundleData;
}

function getBundleDataByProduct({
  activeBundlesMap,
  productKeys,
  edition = FREE_EDITION_LABEL_KEY.toLowerCase()
}: GetBundleDataOptions): BundleData | undefined {
  if (productKeys) {
    const entry = Object.entries(activeBundlesMap).find(
      ([_, rawBundleData]) => {
        return rawBundleData.bundleProductKeys === `${productKeys}`;
      }
    );

    if (entry) {
      const [bundleName, rawBundleData] = entry;
      return {
        ...rawBundleData,
        bundleName,
        edition
      };
    }
  }

  return undefined;
}

function getBundleDataByBundleName({
  activeBundlesMap,
  bundleName,
  edition = FREE_EDITION_LABEL_KEY.toLowerCase()
}: GetBundleDataOptions): BundleData | undefined {
  if (bundleName) {
    const rawBundleData = activeBundlesMap[bundleName];
    if (rawBundleData) {
      return {
        ...rawBundleData,
        bundleName,
        edition
      };
    }
  }

  return undefined;
}
